<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrderDetails/plan"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button v-if="true" type="primary" @click="createPurchasePlan">创建要货计划</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="采购订单：">
          <el-input
              v-model.trim="filter.purchaseOrderNo"
              autosize
              placeholder="请输入采购单号"
              clearable/>
        </vm-search>
        <vm-search label="物料编号：">
          <el-input v-model.trim="filter.partNO" placeholder="请输入物料编号" clearable/>
        </vm-search>
        <vm-search label="出厂编号：">
          <el-input
              v-model.trim="filter.pcorderNo"
              placeholder="请输入出厂编号"
              autosize
              clearable/>
        </vm-search>
        <vm-search label="到货日期：" style="width:200px">
          <div class="block">
            <el-date-picker
                v-model="filter.deliveryDateBegin"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 140px"/>
          </div>
        </vm-search>
        <vm-search label="至" style="width:200px;margin-left:15px">
          <div class="block">
            <el-date-picker
                v-model="filter.deliveryDateEnd"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 140px"/>
          </div>
        </vm-search>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          width="120"
          show-overflow-tooltip/>
      <el-table-column prop="rowNum" align="center" label="行号" width="100"/>
      <el-table-column
          prop="partNo"
          align="center"
          label="物料编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column
          prop="partNameSpec"
          align="left"
          label="物料描述"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" label="交货期" width="100">
        <template v-slot="scope">
          <span>{{scope.row.deliveryDate ? scope.row.deliveryDate.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="pCorderNo"
          align="center"
          label="出厂编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column prop="qty" align="center" label="采购数量" width="80"/>
      <el-table-column prop="planQty" align="center" label="已有计划数量" width="100"/>
      <el-table-column prop="actualQty" align="center" label="计划实收数量" width="100"/>
      <el-table-column prop="unit" align="center" label="单位" width="80"/>
    </vm-table>
    <create-purchase-plan-dialog ref="createPlan" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CreatePurchasePlanDialog from "@/views/purchase/purchasePlan/CreatePurchasePlanDialog";

  export default {
    name: "PurchasePlanAdd",
    components: {VmTable, VmSearch, CreatePurchasePlanDialog},
    data() {
      return {
        filter: {},
        selection: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      createPurchasePlan() {
        if (!this.selection.length) {
          this.$confirm("请选择采购订单行号", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$refs.createPlan.open(this.selection);
        }
      },
    },
  };
</script>

<style>
</style>
